import React from 'react';
import { FiBox, FiDollarSign, FiSmartphone,FiGift } from "react-icons/fi";
import {Link} from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";
import { useTranslation } from "react-i18next";



const CoServiceOne = ({textAlign, serviceStyle}) => {
    const { t } = useTranslation('community');
    const ServiceList = [
    {
        icon: <FiBox />,
        title: t('home.blockchainTitle'),
        description: t('home.blockchainContent'),
    },
    {
        icon: <FiDollarSign />,
        title: t('home.costTitle'),
        description: t('home.costContent'),
    },
    {
        icon: <FiSmartphone />,
        title: t('home.digitalTitle'),
        description: t('home.digitalContent'),
    },
    {
        icon: <FiGift />,
        title: t('home.marketTitle'),
        description: t('home.marketContent'),
    },
    ]
    return (
        <div className='cowrapper'>
            <div className="row row--15 service-wrapper">
                {ServiceList.map( (val , i) => (
                    <div className="col-lg-3 col-md-6 col-sm-6 col-12" key={i}>
                        <ScrollAnimation 
                        animateIn="fadeInUp"
                        animateOut="fadeInOut"
                        animateOnce={true}>
                            <div className={`service ${serviceStyle} ${textAlign}`}>
                                <div className="icon">
                                    {val.icon}
                                </div>
                                <div className="content">
                                    <h4 className="title w-600"><Link to="#service"  style={{fontSize:"20px"}} dangerouslySetInnerHTML={{__html: val.title}}></Link></h4>
                                    <p className="description b1 color-gray mb--0" style={{fontSize:"16px"}} dangerouslySetInnerHTML={{__html: val.description}}></p>
                                </div>
                            </div>
                        </ScrollAnimation>
                    </div>
                ))}
            </div>
        </div>
    )
}
export default CoServiceOne;